import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import promise from "redux-promise-middleware";
import logger from "redux-logger";
import thunk from "redux-thunk";

import user from "../reducers/user";
import policy from "../reducers/policy";
import policies from "../reducers/policies";
import goods from "../reducers/goods";
import insurers from "../reducers/insurers";
import currency from "../reducers/currencies";
import dashboard from "../reducers/dashboard";
import brokers from "../reducers/brokers";
import reports from "../reducers/reports";
import flags from "../reducers/flagged";

import claims from "../reducers/claims";
import payments from "../reducers/payments";
import regions from "../reducers/regions";
import limits from "../reducers/limits";
import rates from "../reducers/rates";
import discounts from "../reducers/discounts";
import branches from "../reducers/branches";
import covers from "../reducers/openCovers";
import quotes from "./../reducers/quotes";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(promise(), thunk, logger));

const reducers = combineReducers({
  user,
  policy,
  insurers,
  currency,
  dashboard,
  brokers,
  flags,
  reports,
  regions,
  policies,
  claims,
  payments,
  limits,
  discounts,
  rates,
  branches,
  covers,
  goods,
  quotes
});

export default () => {
  const store = createStore(reducers, enhancer);
  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js